export default {
  name: "Tooltip-text",
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      default: ""
    },
    lineClamp: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 14
    },
    textAlign: {
      type: String,
      default: "left"
    }
  },
  data() {
    return {
      overflowing: false,
      measureAttempts: 0
    };
  },
  computed: {
    contentStyle() {
      return {
        display: "-webkit-box",
        WebkitLineClamp: this.lineClamp,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        lineHeight: "1.5",
        maxHeight: `${this.lineClamp * 1.5}em`,
        whiteSpace: this.lineClamp === 1 ? "nowrap" : "normal",
        textAlign: this.textAlign
      };
    }
  },
  watch: {
    text() {
      this.$nextTick(this.updateOverflow);
    },
    lineClamp() {
      this.$nextTick(this.updateOverflow);
    }
  },
  mounted() {
    this.updateOverflow();
    this.$nextTick(this.scheduleOverflowCheck);
    if (typeof ResizeObserver !== "undefined") {
      this.resizeObserver = new ResizeObserver(this.updateOverflow);
      this.resizeObserver.observe(this.$refs.containerRef);
    } else {
      window.addEventListener("resize", this.updateOverflow);
    }
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.measureFrame) {
      if (window.cancelAnimationFrame) cancelAnimationFrame(this.measureFrame);else clearTimeout(this.measureFrame);
    }
    window.removeEventListener("resize", this.updateOverflow);
  },
  methods: {
    scheduleOverflowCheck() {
      if (this.measureFrame) {
        if (window.cancelAnimationFrame) cancelAnimationFrame(this.measureFrame);else clearTimeout(this.measureFrame);
      }
      const requestFrame = window.requestAnimationFrame || (callback => setTimeout(callback, 0));
      this.measureFrame = requestFrame(() => {
        this.measureFrame = null;
        this.updateOverflow();
      });
    },
    updateOverflow() {
      var _this$$refs$container;
      const content = (_this$$refs$container = this.$refs.containerRef) === null || _this$$refs$container === void 0 ? void 0 : _this$$refs$container.querySelector(".text-ellipsis-content");
      // 卡片首次挂载或切换布局时可能暂时没有宽度，此时不能误判为溢出。
      if (!content || !this.text || content.clientWidth <= 0) {
        this.overflowing = false;
        if (content && this.measureAttempts < 10) {
          this.measureAttempts += 1;
          this.scheduleOverflowCheck();
        }
        return;
      }
      this.measureAttempts = 0;
      const horizontalOverflow = content.scrollWidth > content.clientWidth;
      const verticalOverflow = this.lineClamp > 1 && content.scrollHeight > content.clientHeight;
      this.overflowing = horizontalOverflow || verticalOverflow;
    }
  }
};